import React from 'react';

export default {
  result: {
    lastInteraction: <>Zeigt die letzten <strong>Interaktionen</strong>:<br/>
      <strong>Nicht angefordert</strong>: keine Stellungnahme angefordert<br/>
      <strong>Anfrage</strong>: Stellungnahme von LAG versendet<br/>
      <strong>Ungelesen</strong>: Stellungnahme noch nicht vom LE gelesen<br/>
      <strong>Gelesen</strong>: Stellungnahme vom LE gelesen<br/>
      <strong>Erinnerung</strong>: An Abgabe der Stellungnahme erinnert<br/>
      <strong>Beantwortet</strong>: Stellungnahme von LE beantwortet<br/>
      <strong>Nicht beantwortet</strong>: Antwort des LE liegt noch nicht vor<br/>
      <strong>Nicht bestätigt</strong>: Stellungnahme von LAG noch nicht bestätigt<br/>
      <strong>Bestätigt</strong>: Eingang der Stellungnahme von LAG bestätigt<br/>
      <strong>Formal korrekt</strong>: Formale Korrektheit von LAG bestätigt<br/>
    </>,
    psnId: <>Die PsnID (<strong>Pseudonym-ID</strong>) ist eindeutig dem Pseudonym zugeordnet. In der Kommunikation ist es einfacher, die PsnID zu nutzen als das Pseudonym</>,
    subModule: <><strong>Auswertungsmodul</strong> gemäß Qualitätsindikatorendatenbank, z.B. HSMDEF-HSM-IMPL für Herzschrittmacher-Implantation oder HGV-HEP für Hüftendoprothesenversorgung</>,
    module: <><strong>Verfahren</strong> gemäß Qualitätsindikatorendatenbank, z.B. HSMDEF für Versorgung mit Herzschrittmachern und implantierbaren Defiblillatoren</>,
    indicatorId: <><strong>Qualitätsindikator</strong> oder Kennzahl gemäß Qualitätsindikatorendatenbank</>,
    evalYear: <><strong>Auswertungsjahr</strong>, in dem die Auswertungen erstellt und das Stellungnahmeverfahren eingeleitet werden</>,
    specYear: <><strong>Spezifikationsjahr</strong>: Hier wird die jeweilige Datensatzversion der zugrundeliegenden Daten angezeigt
      Somit handelt es sich um das Jahr, in dessen Format der Datensatz - ggf. durch Mapping - bereitgestellt wurde</>,
    reportPeriod: <><strong>Berichtszeitraum</strong>: Zeitraum, über den für den Qualitätsindikator berichtet wird</>,
    assessmentCalc: <><strong>Rechnerische Auffälligkeit</strong>: Ja, wenn eine rechnerische Auffälligkeit ermittelt wurde, sonst nein</>,
    ratingCode: <><strong>Bewertung</strong>:<br/>
      <strong>A43</strong>&nbsp; Unzureichend (PlanQI)<br/>
      <strong>A70</strong>&nbsp; Fehlerhafte Dokumentation wird bestätigt<br/>
      <strong>A71</strong>&nbsp; Hinweise auf Struktur- und Prozessmängel<br/>
      <strong>A72</strong>&nbsp; Keine (ausreichend erklärenden) Gründe für die rechnerische Auffälligkeit benannt<br/>
      <strong>A99</strong>&nbsp; Sonstige qualitative Auffälligkeit<br/>
      <strong>D80</strong>&nbsp; Unvollzählige oder falsche Dokumentation<br/>
      <strong>D81</strong>&nbsp; Softwareprobleme haben eine falsche Dokumentation verursacht<br/>
      <strong>D99</strong>&nbsp; Sonstiges (Dokumentationsfehler)<br/>
      <strong>H99</strong>&nbsp; Einrichtung auf rechnerisch auffälliges Ergebnis hingewiesen<br/>
      <strong>N01</strong>&nbsp; Qualitätsindikator ohne Ergebnis<br/>
      <strong>N02</strong>&nbsp; Referenzbereich ist für diesen Indikator nicht definiert<br/>
      <strong>N99</strong>&nbsp; Bewertung nicht vorgesehen<br/>
      <strong>R10</strong>&nbsp; Ergebnis rechnerisch unauffällig<br/>
      <strong>S92</strong>&nbsp; Stellungnahmeverfahren konnte noch nicht abgeschlossen werden<br/>
      <strong>S99</strong>&nbsp; Sonstiges<br/>
      <strong>U34</strong>&nbsp; Zureichend (PlanQI)<br/>
      <strong>U60</strong>&nbsp; Korrekte Dokumentation wird bestätigt<br/>
      <strong>U61</strong>&nbsp; Besondere klinische Situation<br/>
      <strong>U62</strong>&nbsp; Das abweichende Ergebnis erklärt sich durch Einzelfälle<br/>
      <strong>U63</strong>&nbsp; Kein Hinweis auf Mängel der med. Qualität (vereinzelte Dokumentationsprobleme)<br/>
      <strong>U99</strong>&nbsp; Sonstige qualitative Unauffälligkeit<br/>
    </>,
    result: <><strong>Ergebnis</strong>: errechneter Wert, der sich aus Anwendung von Zähler und Nenner ergibt.</>,
    refOp: <><strong>Vergleichsoperator</strong> für den Referenzbereich</>,
    refValue: <><strong>Referenzwert</strong>: wird als Vergleichswert herangezogen, um das ermittelte Ergebnis einzuordnen (Wert des Referenzbereichs)</>,
    numerator: <><strong>Zählerwert des Ergebnisses</strong>: Bei O/E-Ergebnissen handelt es sich um den Zähler der O-Kennzahl (observed)</>,
    denominator: <><strong>Nennerwert des Ergebnisses</strong>: Größe der Grundgesamtheit</>,
    abnormalOps: <><strong>Anzahl der auffälligen Vorgänge</strong> pro Qualitätsindikator und Einrichtung</>,
    qikType: <><strong>Richtlinie</strong>:<br/>
      <strong>QI</strong>:&nbsp; Qualitätsindikator<br/>
      <strong>AK</strong>:&nbsp; Auffälligkeitskriterium<br/>
      <strong>TKez</strong>:&nbsp; Transparenzkennzahl<br/>
      <strong>KKez</strong>:&nbsp; Kalkulatorische Kennzahl<br/>
      <strong>EKez</strong>:&nbsp; Ergänzende Kennzahl<br/>
      <strong>NKez</strong>:&nbsp; Nebenkennzahl<br/>
    </>,
    qualityReport: 'Wird das Ergebnis im Qualitätsbericht veröffentlicht?',
    origin: <><strong>Richtlinie</strong>:<br/>
      <strong>DeQS</strong>:&nbsp; DeQS-Richtlinie<br/>
      <strong>PlanQI</strong>:&nbsp; PlanQI-Richtlinie<br/>
      <strong>Land</strong>:&nbsp; Landesverträge<br/>
      <strong>DeQS-QB</strong>:&nbsp; Qualitätsberichts-Kommentierung von bundesbezogenen Ergebnissen nach DeQS-Richtlinie<br/>
    </>,
    evalDate: <><strong>Erzeugungsdatum</strong> der Auswertungsdatei</>,
    resultComment: 'Wurde dieses Ergebnis vom Leistungserbringer für den Qualitätsbericht kommentiert?',
    hasStatementProcesses: 'Wurde für dieses Ergebnis eine Stellungnahme angefordert oder nicht?',
    lagRatingResponseDate: 'Datum der Ergebnis-Bewertung',
    indicatorType: 'Berechnungsart der Kennzahl, z.B. Rate für ratenbasierte Kennzahlen oder LogRegOdE für logistische Regression (O/E)'
  },
  statement: {
    id: <>Verwenden Sie die <strong>Stellungnahme-ID</strong> (StnID) bei der Kommunikation mit der LAG</>,
    requestDate: <><strong>Anfragedatum</strong>: an diesem Datum wurde das Stellungnahmeverfahren von der LAG eingeleitet</>,
    lastDownloadDate: <>An diesem Datum wurde die Stellungnahme das letzte Mal vom Leistungserbringer gelesen oder heruntergeladen</>,
    answerDate: <><strong>Antwortdatum</strong>: an diesem Datum hat der Leistungserbringer die Stellungnahme beantwortet</>,
    type: <><strong>Typ</strong> der Anfrage. Handelt es sich um eine <strong>Stellungnahme</strong>-Anfrage, die der Leistungserbringer beantworten muss,
      oder eine um eine <strong>Mitteilung</strong>, für die keine Antwort gefordert wird</>,
    state: <><strong>Status</strong> der Stellungnahme:<br/>
      <strong>Gelesen</strong>:&nbsp; die Anfrage wurde vom LE gelesen oder als RTF heruntergeladen<br/>
      <strong>Ungelesen</strong>:&nbsp; die Anfrage wurde noch nicht gelesen/heruntergeladen<br/>
      <strong>Erinnerung</strong>:&nbsp; an die Beantwortung der Anfrage wurde erinnert<br/>
      <strong>Beantwortet, nicht bestätigt</strong>:&nbsp; die Anfrage wurde vom LE beantwortet, die Bestätigung der LAG
      steht noch aus<br/>
      <strong>Beantwortet</strong>:&nbsp; die Anfrage wurde vom LE beantwortet<br/>
      <strong>Formal korrekt</strong>:&nbsp; die LAG hat die formale Korrektheit der Anfrage bestätigt<br/>
      <strong>Nicht bestätigt</strong>:&nbsp; die LAG hat den Eingang der Antwort bzw. die formale Korrektheit nicht
      bestätigt<br/>
      <strong>Im LE-Postfach</strong>:&nbsp; die Antwort liegt im Postfach des LE. Sie ist damit noch nicht beantwortet und muss noch versendet werden<br/>
    </>,
    hasAttachments: 'Wurden bei der Beantwortung der Stellungnahme Anhänge wie Word-Dateien verwendet?',
    poolRequest: <>Welche <strong>Anfrage-Vorlage</strong> wurde bei der Erstellung der Stellungnahme verwendet?</>,
    toReminderDate: <><strong>Erinnerungsdatum</strong>: an diesem Datum wurde der LE an die Beantwortung der Stellungnahme erinnert</>,
    toAnswerDate: <><strong>Frist</strong>: Ende der Frist zur Beantwortung der Stellungnahme</>,
    toSubsequentDeliveryDate: <><strong>Nachlieferfrist</strong>: Ende der Nachlieferfrist zur Beantwortung der Stellungnahme</>,
  },
  document: {
    uploadDate: <><strong>Upload-Datum</strong>: an diesem Datum wurde das Dokument bereitgestellt</>,
    expireDate: <><strong>Ablauf-Datum</strong>, an dem die Gültigkeit des Dokuments endet und für die Mitarbeiter nicht mehr sichtbar ist</>,
    lastDownloadDate: <><strong>Download-Datum</strong>: Datum, an dem das Dokument heruntergeladen wurde,
      oder Kreis der Adressaten, wenn es sich um mehrere Adressaten handelt</>,
    username: <>Name des Mitarbeiters, der das Dokument hochgeladen hat</>,
    title: <><strong>Titel</strong> des Dokuments</>,
    module: <><strong>Verfahren</strong>, für welches das Dokument bereitgestellt wurde oder ---, wenn allgemeingültig</>,
    accessLabel: <>Rolle, für welche das Dokument freigegeben bzw. sichtbar ist</>,
    archived: <>Wurde das Dokument archiviert? Über den Filter können Sie auch die archivierten Dokumente einsehen.</>,
  },
  chat: {
    id: <><strong>GUID</strong>: globaler Identifikator der Nachricht</>,
    subject: <><strong>Betreff</strong> des gesamten Nachrichtenverlaufs</>,
    createdAt: <>Zeitpunkt, an dem die <strong>erste Nachricht</strong> dieses Nachrichtenverlaufs gesendet wurde</>,
    lastResponse: <>Zeitpunkt, an dem die <strong>letzte Nachricht</strong> dieses Nachrichtenverlaufs gesendet wurde</>,
    messageCount: <><strong>Anzahl</strong> an Einzelnachrichten in diesem Nachrichtenverlauf</>,
    isRead: <>Wurde die letzte Nachricht dieses Nachrichtenverlaufs gelesen?</>,
    archivedAt: <>Wurde dieser Nachrichtenverlauf archiviert? Über den Filter können Sie auch die archivierten Nachrichten einsehen.</>,
  },
  encrypt: {
    employee: <>Name des Mitarbeiters, der die Depseudonymisierung durchgeführt hat</>,
    careProvider: <>Leistungserbringer, der depseudonymisiert wurde</>,
    createdAt: <>Zeitpunkt der Depseudonymisierung</>,
    forAllLagGs: <>Wurde die Depseudonymisierung für alle LAG-Mitarbeiter durchgeführt?</>,
  },
  employee: {
    lastName: <><strong>Nachname</strong> des Mitarbeiters</>,
    firstName: <><strong>Vorname</strong> des Mitarbeiters</>,
    title: <><strong>Titel</strong> des Mitarbeiters</>,
    phone: <><strong>Telefonnummer</strong>, unter welcher der Mitarbeiter zu erreichen ist</>,
    mail: <><strong>Mailadresse</strong> des Mitarbeiters</>,
    careProvider: <>Leistungserbringer, für welche der Mitarbeiter die Zugriffsrechte hat</>,
    role: <><strong>Rolle</strong> des Mitarbeiters:<br/>Administrator<br/>Datenannahmestelle<br/>Fachkommission<br/>Geschäftsstelle<br/>Krankenhaus<br/>
      Vertragsarzt<br/>Externer Mitarbeiter<br/>Datenannahmestelle (KH)<br/>Datenannahmestelle (KV)<br/>Administrator (KH)</>,
    accessGrants: <><strong>Berechtigungen</strong> im Stellungnahmeverfahren: Lesen, Schreiben, Senden beim Erstellen einer Stellungnahme oder beim Beantworten</>,
    validSince: <>Beginn des Gültigkeitszeitraumes</>,
    validTo: <>Ende des Gültigkeitszeitraumes oder leer, wenn der Mitarbeiter noch aktiv ist</>,
    lastLogin: <>Datum der letzten <strong>Anmeldung</strong></>,
  },
  careProvider: {
    name: <><strong>Name</strong> des Leistungserbringers</>,
    pseudonym: <>Das <strong>Pseudonym </strong>ersetzt Institutionskennzeichen, Betriebsstättennummer und StandortId und wird vom IQTIG vergeben</>,
    identNumber: <>Identifikationsnummer: <strong>Institutionskennzeichen</strong> bei stationären Leistungserbringern oder <strong>Betriebsstättennummer</strong> bei vertragsärztlichen Leistungserbringern</>,
    identNumberPlusDest: <>Identifikationsnummer: <strong>Institutionskennzeichen</strong> und <strong>StandortId</strong> bei stationären Leistungserbringern oder <strong>Betriebsstättennummer</strong> bei vertragsärztlichen Leistungserbringern</>,
    destinationKey: <><strong>StandortId</strong> von stationären Leistungserbringern</>,
    validSince: <>Beginn des Gültigkeitszeitraumes</>,
    validTo: <>Ende des Gültigkeitszeitraumes oder leer, wenn der Leistungserbringer noch aktiv ist</>,
    kv: <><strong>KH</strong> (Krankenhaus) oder <strong>VA</strong> (Vertragsarzt)</>
  },
  targetActual: {
    identNumber: <>Identifikationsnummer: <strong>Institutionskennzeichen</strong> und <strong>StandortId</strong> bei stationären Leistungserbringern oder <strong>Betriebsstättennummer</strong> bei vertragsärztlichen Leistungserbringern</>,
    name: <><strong>Bezeichnung</strong> des Dokumentationsmoduls</>,
    year: <><strong>Spezifikationsjahr</strong> der Dokumentation</>,
    module: <><strong>Bezeichnung</strong> des Dokumentationsmoduls</>,
    countingModule: <><strong>Zählleistungsbereich</strong> des Dokumentationsmoduls</>,
    actual: <><strong>Ist</strong>: Anzahl bestätigter Datensätze des Dokumentationsmoduls (Innenlieger)</>,
    actualPrevious: <><strong>Ist VJ</strong>: Anzahl bestätigter Datensätze des Dokumentationsmoduls (Überlieger, Aufnahme im Vorjahr)</>,
    target: <><strong>Soll</strong> gemäß Angabe in der Sollstatistik</>,
    rate: <><strong>Dokumentationsrate</strong> = Ist / (Soll + Soll Vorjahr)</>,
    comment: <>Wurde die Dokumentationsrate vom Leistungserbringer für den Qualitätsbericht kommentiert?</>
  },
  report: {
    guideline: <><strong>Richlinie</strong>: DeQS, PlanQI oder Landesverfahren</>,
    type: <><strong>Rückmeldebericht</strong> (ehemals Jahresbericht) oder <strong>Zwischenbericht</strong> (ehemals
      Quartalsbericht)</>,
    date: <><strong>Zeitraum</strong>: ganzes Auswertungsjahr bzw. ein oder mehrere Quartale</>,
    releaseDate: <><strong>Veröffentlichungsdatum</strong> des Berichts beim IQTIG</>,
    lastDownloadDate: <>Datum des letzten letzten Downloads durch den Leistungserbringer</>
  },
  xmlUpload: {
    originalName: <>Name der hochgeladenen XML-Datei &lt;GUID&gt;_Q_LE.xml mit den QS-Daten</>,
    uploadDate: <>Datum, an dem die XML-Datei hochgeladen wurde</>,
    username: <>Name des Mitarbeiters, der die XML-Datei hochgeladen hat</>,
    responseDate: <>Datum, an dem die Antwortdatei von der Datenannahmestelle eingetroffen ist</>,
    downloadDate: <>Datum, an dem die Antwortdatei von dem Mitarbeiter heruntergeladen wurde</>
  },
  edok: {
    id: <><strong>&lt;GUID&gt;</strong>: global eindeutige ID zur Identifikation des Dokuments</>,
    year: <><strong>Erfassungsjahr</strong> oder Spezifikationsjahr des Dokuments</>,
    module: <><strong>Dokumentationsmodul</strong>: NWIES (stationär) oder NWIEA (ambulant)</>,
    identNumber: <><strong>Betriebsstättennummer</strong> der vertragsärztlichen Einrichtung</>,
    state: <><strong>Status</strong> des Dokuments:<br/><strong>In Arbeit</strong>: enthält noch Plausibilitätsfehler<br/>
      <strong>korrekt</strong>: vollständig und korrekt ausgefüllt<br/>
      <strong>versendet</strong>: an die Datenannahmestelle versendet<br/>
      <strong>bestätigt</strong>: abschließend von der Datenannahmestelle bestätigt<br/>
      <strong>abgewiesen</strong>: Fehler bei der Verarbeitung bei der Datenannahmestelle</>
    }
}

